import React from 'react';
import PropTypes from 'prop-types';
import isRequiredIf from '../../modules/react-conditional-required';
import { Row, Col, ControlLabel, Button } from 'react-bootstrap';
import I18n from 'i18n-react';
import './FlightClassTypePrice.css';
import { FareOriginType } from '../../../const/PNRItemModel';

const propTypes = {
  id: PropTypes.string.isRequired,
  isAvailable: PropTypes.bool,
  value: isRequiredIf(PropTypes.number, props => props.isAvailable),
  onClick: PropTypes.func,
  classType: PropTypes.string,
  rangeDefault: PropTypes.shape({
    points: PropTypes.number,
    amount: PropTypes.number,
    order: PropTypes.number,
    isDefault: PropTypes.bool
  })
};

const defaultProps = {
  isAvailable: false,
  value: null,
  classType: null,
  rangeDefault: null
};

class FlightClassTypePrice extends React.Component {

  formatPoints(points) {
    const pattern = /\B(?=(\d{3})+(?!\d))/g;
    return points.toString().replace(pattern, '.');
  }

  formatAmount(amount) {
    return amount
      .toFixed(2)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+,)/g, '$1.');
  }

  renderButtonAvailable() {
    let flightButtonLabel =
      this.props.id === 'selectEconomy'
        ? 'components.flightGrid.economy'
        : 'components.flightGrid.business';
    return (
      <div>
        <Col smHidden mdHidden lgHidden className="labelFlightButton">
          <ControlLabel>{I18n.translate(flightButtonLabel)}</ControlLabel>
        </Col>
        <Col className="pointsPlusMoneyContainer">
          <Col className="cardPlusMoney">
            <Col className="cardLabelPointsPlusMoney">
              <Col className="labelValuePoints">{this.formatPoints(this.props.value)}</Col>
              <Col className="labelPoints">{I18n.translate('pointsPlusMoney.availableFlights.msgPoints')}</Col>
            </Col>
            {this.renderPointsPlusMoney()}
          </Col>
          <Button
            id={`btnPrice-${this.props.id}`}
            bsClass="btnPriceClassTypeSelect"
            onClick={() => this.props.onClick(this.props.value)}
            ref={c => {
              this.btnPrice = c;
            }}>
            <Col className='labelButtonSelect'>{I18n.translate('pointsPlusMoney.availableFlights.msgButtonSelect')}</Col>
          </Button>
        </Col>
      </div>
    )
  }

  renderButtonUnavailable() {
    let flightButtonLabel =
      this.props.id === 'selectEconomy'
        ? 'components.flightGrid.economy'
        : 'components.flightGrid.business';
    return (
      <div>
        <Col smHidden mdHidden lgHidden className="labelFlightButton">
          <ControlLabel>{I18n.translate(flightButtonLabel)}</ControlLabel>
        </Col>
        <Col className="pointsPlusMoneyContainer">
          <Button
            id={`btnPrice-${this.props.id}`}
            bsClass="btnPriceClassTypeSelectUnavailable"
            ref={c => {
              this.btnPrice = c;
            }}>
            <Col className='labelUnavailablebtnPriceClassTypeSelect'>{I18n.translate(`components.flightPrice.optionUnavailable`)}</Col>
          </Button>
        </Col>
      </div>
    )
  }

  renderPointsPlusMoney() {
    const isRender = this.props.rangeDefault;
    return (
      <div className="labelPointsPlusMoney">
        {isRender  ? I18n.translate('pointsPlusMoney.availableFlights.msgPointsPlusMoney', {
          points: this.props.rangeDefault.points ? this.formatPoints(this.props.rangeDefault.points) : '',
          money:  this.props.rangeDefault.amount ? this.formatAmount(this.props.rangeDefault.amount) : ''
        }) : ''}
      </div>
    )
  }

  renderButton() {
    if (this.props.isAvailable) {
      return this.renderButtonAvailable();
    } else {
      return this.renderButtonUnavailable();
    }
  }

  render() {
    return (
      <div id={`FlightClassTypePrice-${this.props.id}`} className="FlightClassTypePrice">
        <Row>
          {<Col>{this.renderButton()}</Col>}
        </Row>
      </div>
    );
  }
}

FlightClassTypePrice.propTypes = propTypes;
FlightClassTypePrice.defaultProps = defaultProps;
export default FlightClassTypePrice;



// WEBPACK FOOTER //
// ./src/components/flightSelection/flightClassTypePrice/FlightClassTypePrice.jsx